import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const tabContent: SxStyle = {
  width: '100%',
  height: '100%',
};

export const scrollbar: SxStyle = {
  height: '100%',

  '& .simplebar-content': {
    height: '100%',
  },
};

export const tabPanel: SxStyle = {
  padding: 0,
};

export const labelWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1.25),
};

export const searchValueWrapper: SxStyleFunc<boolean | undefined> = (
  isCurrentTab
) => ({
  display: 'flex',
  alignItems: 'center',
  height: (p) => p.spacing(2.5),
  padding: (p) => p.spacing(0, 1),
  borderRadius: (p) => p.spacing(0.5),
  background: isCurrentTab
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.grey[300],
  color: isCurrentTab
    ? (p) => p.palette.common.white
    : (p) => p.palette.grey[500],
});

export const value: SxStyleFunc<boolean | undefined> = (isCurrentTab) => ({
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: isCurrentTab
    ? (p) => p.typography.fontWeightBold
    : (p) => p.typography.fontWeightMedium,
  color: isCurrentTab
    ? (p) => p.palette.common.white
    : (p) => p.palette.grey[500],
});

export const tabsWrapper: SxStyle = {
  borderBottom: (p) => `1px solid ${p.palette.grey[300]}`,
};

export const emptyIconWrapperSX: SxStyle = {
  padding: (p) => p.spacing(3, 1),
};

export const dataNotFoundWrapper: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
